import script from "./ClientInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./ClientInfo.vue?vue&type=script&lang=ts&setup=true"

import "./ClientInfo.vue?vue&type=style&index=0&id=2a1fca0e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a1fca0e"]])

export default __exports__